import React from "react";
// ---- Style ---- //
import "./index.scss";

// ---- Components ---- //

const Clients = () => {
  return <div className="clients"></div>;
};

export default Clients;
